import jquery from "jquery"

import {moduleConfig} from "../gisConfig.js";

let _widgetsInfo = {};
let _map = undefined;
let _self = undefined;

export default class WidgetManager{

  constructor(option) {
    _map = option.map
    this._widgets = {};
    this.MINX = 100;
    this.MINY = 100;
    this.INCREASE_NUM = 100;
    this._mapDomId = option.mapDomId;
    _self = this;
    this.initialize();
  }

  initialize(){
    this.createWidget()
    jquery.subscribe("openWidgetCmdEvent", (e, data)=>{
      _self.openWidget(data);
    });
  }

  createWidget(){
    let i, iMax;
    let module;
    for(i = 0, iMax = moduleConfig.length; i < iMax; ++i){
      module = moduleConfig[i];
      _widgetsInfo[module.name] = module;
      if(module.must){
        if(module.type === "quickBar"){
          this.loadQuickBarWidget(module);
        }
        else if(module.type === "widget"){
          this.bindClickMethod(module);
        }
        else if(module.type === "service"){
          this.loadServicesWidget(module);
        }
      }
    }
  }

  loadQuickBarWidget(widgetInfo){

  }

  bindClickMethod(widgetInfo){
    let _this = this;
    jquery("#"+widgetInfo.uiid).on("click", function () {
      _this.loadWidget(widgetInfo);
    })
  }

  loadWidget(widgetInfo){
    if(this._widgets[widgetInfo.name]){
      this._widgets[widgetInfo.name].show();
      return;
    }
    let option = {};
    let widgetCount = Object.getOwnPropertyNames(this._widgets).length;
    if(widgetInfo.top) {
      option.top = widgetInfo.top;
    }
    else{
      option.top = this.MINX + widgetCount * this.INCREASE_NUM;
    }
    if(widgetInfo.left) {
      option.left = widgetInfo.left;
    }
    else{
      option.left = this.MINY + widgetCount * this.INCREASE_NUM;
    }
    option.name = widgetInfo.name;
    option.label = widgetInfo.label;
    option.mapDomId = this._mapDomId;
    option.startupParam = widgetInfo.startupParam || undefined;
  }

  loadServicesWidget(widgetInfo){

  }

  openWidget(data){
    let widgetInfo = _widgetsInfo[data.widget];
    if(widgetInfo){
      if(this._widgets[widgetInfo.name]){
        let cmd = {
          "startupParam":data.startupParam
        }
        jquery.publish(data.widget+"CmdEvent", cmd);
      }
      else{
        widgetInfo.startupParam = data.startupParam;
        if(data.top){
          widgetInfo.top = data.top;
        }
        if(data.left){
          widgetInfo.left = data.left;
        }
        this.loadWidget(widgetInfo)
      }
    }
    else{
      alert(data.widget+"模块未加载！");
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/EXGis/module/WidgetManager.js